import React, { ChangeEvent, useRef } from 'react';

interface BtnActionReuploadProps {
  reuploadChange: (e: ChangeEvent<HTMLInputElement>) => void;
  authorizedFiles: string[];
}

export const BtnActionReupload = (props: BtnActionReuploadProps) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const strTitle = 'Réenvoyer';
  const strTitle2 = 'un fichier';

  return (
    <div className="col-lg-4 col-md-4 col-12  d-flex my-2 my-lg-0 align-items-center">
      <span className="d-none">
        <input ref={inputRef} onChange={props.reuploadChange} type="file" name="file" accept={props.authorizedFiles.join((','))} />
      </span>
      <button
        className="d-flex flex-column flex-lg-row  cursor-pointer w-100  text-center d-flex btnBatAuto btnBatAutoPrimary justify-content-center align-items-center  black text-center"
        onClick={() => inputRef.current?.click()}
      >
        <span className="bold">
          {strTitle}
        </span>
        <span>&nbsp;{strTitle2}</span>
      </button>
    </div>
  );
}